import { HIDE_SUGGESTIONS, TOGGLE_SUGGESTIONS } from './actionTypes/suggestions';

export const closeCallSuggestions = () => ({ type: HIDE_SUGGESTIONS });
export const toggleCallSuggestions = () => ({ type: TOGGLE_SUGGESTIONS });
